import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import styles from 'components/transactionEditor/ActionButtons.module.css';
import { useTranslation } from 'react-i18next';
import { Credentials } from 'types/rest/dslTypes';
import BzmIcon from '../icons/BzmIcon';

interface RequestCredentialsProps {
  id: string;
  credentials: Credentials | null;
  onAdd: () => void;
  onChange: (name: string, value: string) => void;
  onDelete: () => void;
  isReadOnly?: boolean;
}

export type CredentialsField = 'username' | 'password';

const RequestCredentials = (props: RequestCredentialsProps) => {
  const { t } = useTranslation('transactions');
  const handleChange = (e: any) => {
    const target = e.target as HTMLInputElement;
    props.onChange(target.name as CredentialsField, target.value);
  };

  return (
    <div id={props.id}>
      {!props.credentials || (props.credentials.username === null && props.credentials.password === null) ? (
        <div id={props.id}>
          <p>{t('editor.noCredentialsMessage')}</p>
          <Button
            disabled={props.isReadOnly}
            id="qa-btn-add-credentials"
            onClick={props.onAdd}
            className="btn btn-primary btn-circular"
            title={t('editor.addCredentials')}
          >
            <BzmIcon variant={'icon-bzm-add'} />
          </Button>
        </div>
      ) : (
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="qa-input-creds-username">
              <Form.Label>{t('editor.username')}</Form.Label>
              <Form.Control
                disabled={props.isReadOnly}
                name="username"
                onChange={handleChange}
                placeholder={'Enter ' + t('editor.username') + '...'}
                value={props.credentials.username}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="qa-input-creds-password">
              <Form.Label>{t('editor.password')}</Form.Label>
              <Form.Control
                disabled={props.isReadOnly}
                name="password"
                type="text"
                className={'passwordInput'}
                onChange={handleChange}
                placeholder={'Enter ' + t('editor.password') + '...'}
                value={props.credentials.password}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <span className={styles.actionButtons}>
              <Button
                disabled={props.isReadOnly}
                id="qa-btn-creds-delete"
                onClick={props.onDelete}
                variant="danger"
                className="btn-circular"
                title={t('editor.deleteCredentials')}
              >
                <BzmIcon variant={'icon-bzm-delete'} />
              </Button>
            </span>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default RequestCredentials;
